document.addEventListener('scroll', function () {
  if (window.innerWidth <= 843) {
    // Get the elements for both slots
    const heroProductOne = document.querySelector('.collection-hero-product');
    const heroImgOne = document.querySelector('.collection-hero-img');
    const heroContentOne = document.querySelector('.collection-hero-content');

    const heroProductTwo = document.querySelector('.heroProductTwo');
    const heroImgTwo = document.querySelector('.heroImgTwo');
    const heroContentTwo = document.getElementById('heroContentTwo');

    // Helper function to handle overlap effect for each hero content
    function applyOverlapEffect(heroProduct, heroImg, heroContent) {
      const scrollPosition = window.scrollY;
      const triggerPosition = heroImg.offsetTop;

      if (scrollPosition > triggerPosition) {
        // Apply overlap effect
        heroProduct.style.transform = 'translateY(-130px)';
        heroProduct.style.transition = 'transform 0.5s ease-in-out';

        // Adjust the height of the content dynamically
        const heroProductHeight = heroProduct.getBoundingClientRect().height;
        heroContent.style.height = `${heroImg.offsetHeight + heroProductHeight - 110}px`;
      } else {
        // Reset the overlap and height when scrolling up
        heroProduct.style.transform = 'translateY(0)';
        heroProduct.style.transition = 'transform 0.5s ease-in-out';
        heroContent.style.height = `${heroImg.offsetHeight + heroProduct.offsetHeight}px`;
      }
    }

    // Apply overlap effect for each hero content slot
    if (heroProductOne && heroImgOne && heroContentOne) {
      applyOverlapEffect(heroProductOne, heroImgOne, heroContentOne);
    }
    if (heroProductTwo && heroImgTwo && heroContentTwo) {
      applyOverlapEffect(heroProductTwo, heroImgTwo, heroContentTwo);
    }
  } else {
    const heroContentOne = document.querySelector('.collection-hero-content');
    const heroContentTwo = document.getElementById('heroContentTwo');

    const heroProductOne = document.querySelector('.collection-hero-product');
    const heroProductTwo = document.querySelector('.heroProductTwo');

    [heroContentOne, heroContentTwo].forEach(el => { if (el) el.style.height = ''; });
    [heroProductOne, heroProductTwo].forEach(el => { if (el) el.style.transform = ''; });
  }
});

const imageContainers = document.querySelectorAll('.collection-hero-product-img');

if (imageContainers.length > 0) {
  imageContainers.forEach(imageContainer => {
    const onHoverSecondImage = imageContainer.getAttribute('onHoverSecondImage');

    if (onHoverSecondImage) {
      const mainImage = imageContainer.querySelector('img');
      const mainImageSrc = mainImage.src;

      imageContainer.addEventListener('mouseover', function () {
        mainImage.src = onHoverSecondImage; // Display the second image on hover
      });

      imageContainer.addEventListener('mouseout', function () {
        mainImage.src = mainImageSrc; // Revert to the first image when hover ends
      });
    }
  });
}
